var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n, utils, liquid } from '@easydata/core';
import { DialogFooterAlignment } from './dialog_service';
import { domel } from '../utils/dom_elem_builder';
var cssPrefix = "kdlg";
var DefaultDialogService = /** @class */ (function () {
    function DefaultDialogService() {
    }
    DefaultDialogService.prototype.openConfirm = function (title, content, callback) {
        var _this = this;
        var template = "<div id=\"" + cssPrefix + "-dialog-confirm\">" + content + "</div>";
        var options = {
            title: title,
            closable: false,
            submitable: true,
            cancelable: true,
            body: template
        };
        if (callback) {
            options.onSubmit = function () {
                callback(true);
            };
            options.onCancel = function () {
                callback(false);
            };
            this.open(options);
            return;
        }
        return new Promise(function (resolve) {
            options.onSubmit = function () {
                resolve(true);
            };
            options.onCancel = function () {
                resolve(false);
            };
            _this.open(options);
        });
    };
    DefaultDialogService.prototype.openPrompt = function (title, content, defVal, callback) {
        var _this = this;
        var template = "<div id=\"" + cssPrefix + "-dialog-form\" class=\"kfrm-form\">\n            <div class=\"kfrm-fields label-above\">\n                <label for=\"" + cssPrefix + "-dialog-form-input\" id=\"" + cssPrefix + "-dialog-form-content\">" + content + "</label>\n                <input type=\"text\" name=\"" + cssPrefix + "-dialog-form-input\" id=\"" + cssPrefix + "-dialog-form-input\" />\n            </div>\n        </div>";
        var options = {
            title: title,
            submitable: true,
            closable: true,
            cancelable: true,
            submitOnEnter: true,
            body: template,
            arrangeParents: false,
            beforeOpen: function () {
                var input = document.getElementById(cssPrefix + "-dialog-form-input");
                if (defVal) {
                    input.value = defVal;
                }
                input.focus();
            }
        };
        var processInput = function (callback) {
            var input = document.getElementById(cssPrefix + "-dialog-form-input");
            var result = input.value;
            if (result && result.replace(/\s/g, '').length > 0) {
                callback(result);
                return true;
            }
            input.classList.add('eqjs-invalid');
            return false;
        };
        if (callback) {
            options.onSubmit = function () {
                return processInput(callback);
            };
            options.onCancel = function () {
                callback("");
            };
            this.open(options);
            return;
        }
        return new Promise(function (resolve) {
            options.onSubmit = function () {
                return processInput(resolve);
            };
            options.onCancel = function () {
                resolve("");
            };
            _this.open(options);
        });
    };
    DefaultDialogService.prototype.open = function (options, data) {
        var _this = this;
        var dialog = new DefaultDialog(options, data);
        var onDestroy = options.onDestroy;
        options.onDestroy = function (dlg) {
            _this.untrack(dlg);
            onDestroy && onDestroy(dlg);
        };
        dialog.open();
        this.track(dialog);
        return dialog;
    };
    DefaultDialogService.prototype.createSet = function (options) {
        return new DefaultDialogSet(options, this);
    };
    DefaultDialogService.prototype.untrack = function (dlg) {
        var index = DefaultDialogService.openDialogs.indexOf(dlg);
        if (index >= 0) {
            DefaultDialogService.openDialogs.splice(index, 1);
        }
    };
    DefaultDialogService.prototype.track = function (dlg) {
        DefaultDialogService.openDialogs.push(dlg);
    };
    DefaultDialogService.prototype.openProgress = function (options) {
        var _this = this;
        var dialog = new DefaultProgressDialog(options);
        var onDestroy = options.onDestroy;
        options.onDestroy = function (dlg) {
            _this.untrack(dlg);
            onDestroy && onDestroy(dlg);
        };
        dialog.open();
        this.track(dialog);
        return dialog;
    };
    DefaultDialogService.prototype.getAllDialogs = function () {
        return Array.from(DefaultDialogService.openDialogs);
    };
    DefaultDialogService.prototype.closeAllDialogs = function () {
        for (var _i = 0, _a = Array.from(DefaultDialogService.openDialogs); _i < _a.length; _i++) {
            var dialog = _a[_i];
            dialog.close();
        }
    };
    DefaultDialogService.openDialogs = [];
    return DefaultDialogService;
}());
export { DefaultDialogService };
var DefaultDialog = /** @class */ (function () {
    function DefaultDialog(options, data) {
        var _this = this;
        this.options = options;
        this.submitHandler = function (token) {
            if (_this.options.onSubmit && _this.options.onSubmit(_this, token) === false) {
                return false;
            }
            _this.destroy();
            return true;
        };
        this.cancelHandler = function () {
            if (_this.options.onCancel) {
                _this.options.onCancel(_this);
            }
            _this.destroy();
        };
        this.keydownHandler = function (ev) {
            if (ev.keyCode == 13 && _this.isActiveDialog()) {
                ev.preventDefault();
                ev.stopPropagation();
                if (_this.submitHandler()) {
                    window.removeEventListener('keydown', _this.keydownHandler, false);
                    return false;
                }
            }
            return true;
        };
        this.dialogId = utils.generateId('dlg');
        this.data = data;
        this.slot =
            domel('div', document.body)
                .attr('tab-index', '-1')
                .data('dialog-id', this.dialogId)
                .addClass(cssPrefix + "-modal", 'is-active')
                .focus()
                .addChild('div', function (b) { return b
                .addClass('kdlg-modal-background'); })
                .addChild('div', function (b) { return _this.windowElement = b
                .addClass(cssPrefix + "-modal-window")
                .addChild('header', function (b) {
                _this.headerElement = b
                    .addClass(cssPrefix + "-header")
                    .addChild('p', function (b) { return b
                    .addClass(cssPrefix + "-header-title")
                    .addText(options.title); })
                    .toDOM();
                if (options.closable !== false)
                    b.addChild('button', function (b) { return b
                        .addClass(cssPrefix + "-modal-close")
                        .on('click', function () {
                        _this.cancelHandler();
                    })
                        .focus(); });
            })
                .addChild('div', function (b) {
                b.addClass(cssPrefix + "-alert-container");
                _this.alertElement = b.toDOM();
            })
                .addChild('section', function (b) {
                _this.bodyElement = b
                    .addClass(cssPrefix + "-body")
                    .toDOM();
                if (typeof options.body === 'string') {
                    var html = liquid.renderLiquidTemplate(options.body, data);
                    b.addHtml(html);
                }
                else {
                    b.addChildElement(options.body);
                }
            })
                .addChild('footer', function (b) {
                var alignClass = null;
                if (options.footerAlignment && options.footerAlignment == DialogFooterAlignment.Center) {
                    alignClass = 'align-center';
                }
                else {
                    alignClass = 'align-right';
                }
                _this.footerElement = b
                    .addClass(cssPrefix + "-footer")
                    .toDOM();
                b.addClass(alignClass);
                if (options.submitable === false)
                    return;
                b.addChild('button', function (bb) {
                    bb.id(_this.dialogId + '-btn-submit')
                        .addClass('kfrm-button', 'is-info')
                        .addText(options.submitButtonText || i18n.getText('ButtonOK'));
                    if (options.recaptchaSiteKey) {
                        bb.data('sitekey', options.recaptchaSiteKey);
                        bb.addClass('g-recaptcha');
                        bb.on('click', function (e) {
                            if (grecaptcha) {
                                grecaptcha.ready(function () {
                                    grecaptcha.execute(options.recaptchaSiteKey, { action: 'submit' })
                                        .then(function (token) {
                                        _this.submitHandler(token);
                                    });
                                });
                            }
                            else {
                                _this.submitHandler();
                            }
                        });
                    }
                    else {
                        bb.on('click', function (e) {
                            _this.submitHandler();
                        });
                    }
                    bb.focus();
                });
                if (options.cancelable !== false)
                    b.addChild('button', function (bb) { return bb
                        .id(_this.dialogId + '-btn-cancel')
                        .addClass('kfrm-button')
                        .addText(options.cancelButtonText || i18n.getText('ButtonCancel'))
                        .on('click', function (e) {
                        _this.cancelHandler();
                    }); });
            })
                .toDOM(); })
                .toDOM();
    }
    DefaultDialog.prototype.getData = function () {
        return this.data;
    };
    DefaultDialog.prototype.getRootElement = function () {
        return this.slot;
    };
    DefaultDialog.prototype.getSubmitButtonElement = function () {
        return document.getElementById(this.dialogId + '-btn-submit');
    };
    DefaultDialog.prototype.getCancelButtonElement = function () {
        return document.getElementById(this.dialogId + '-btn-cancel');
    };
    DefaultDialog.prototype.open = function () {
        var _this = this;
        if (this.options.beforeOpen) {
            this.options.beforeOpen(this);
        }
        domel(this.slot).show();
        if (this.options.arrangeParents) {
            this.arrangeParents(true);
        }
        var windowDiv = this.slot
            .querySelector("." + cssPrefix + "-modal-window");
        if (this.options.height) {
            windowDiv.style.height = typeof this.options.height === 'string'
                ? this.options.height
                : this.options.height + "px";
        }
        if (this.options.width) {
            windowDiv.style.width = typeof this.options.width === 'string'
                ? this.options.width
                : this.options.width + "px";
        }
        if (this.options.submitOnEnter) {
            window.addEventListener('keydown', this.keydownHandler, false);
        }
        //clear alert on change in any input element 
        this.slot.querySelectorAll('input')
            .forEach(function (element) {
            return element.addEventListener('input', function () {
                _this.clearAlert();
                if (_this.options.onInput) {
                    _this.options.onInput(_this);
                }
            });
        });
        if (this.options.onShow) {
            this.options.onShow(this);
        }
    };
    DefaultDialog.prototype.submit = function () {
        this.submitHandler();
    };
    DefaultDialog.prototype.cancel = function () {
        this.cancelHandler();
    };
    DefaultDialog.prototype.close = function () {
        this.destroy();
    };
    DefaultDialog.prototype.disableButtons = function () {
        var buttons = this.slot.querySelectorAll('button');
        buttons.forEach(function (button) { return button.disabled = true; });
    };
    DefaultDialog.prototype.enableButtons = function () {
        var buttons = this.slot.querySelectorAll('button');
        buttons.forEach(function (button) { return button.disabled = false; });
    };
    DefaultDialog.prototype.showAlert = function (text, reason, replace) {
        var alert = domel('div')
            .addClass(cssPrefix + "-alert " + (reason || ''))
            .addChild('span', function (b) { return b
            .addClass(cssPrefix + "-alert-closebtn")
            .text('×')
            .on('click', function (ev) {
            var alert = ev.target.parentElement;
            alert.parentElement.removeChild(alert);
        }); })
            .addText(text)
            .toDOM();
        if (replace === true) {
            this.clearAlert();
        }
        this.alertElement.appendChild(alert);
    };
    DefaultDialog.prototype.clearAlert = function () {
        this.alertElement.innerHTML = '';
    };
    DefaultDialog.prototype.destroy = function () {
        var elem = document.querySelectorAll("[data-dialog-id=\"" + this.dialogId + "\"]");
        if (elem.length <= 0)
            return;
        if (this.options.arrangeParents) {
            this.arrangeParents(false);
        }
        document.body.removeChild(this.slot);
        if (this.options.submitOnEnter) {
            window.removeEventListener('keydown', this.keydownHandler, false);
        }
        if (this.options.onDestroy) {
            this.options.onDestroy(this);
        }
    };
    DefaultDialog.prototype.isActiveDialog = function () {
        var windowDivs = document.documentElement.querySelectorAll('.kdlg-modal');
        return windowDivs[windowDivs.length - 1] === this.slot;
    };
    DefaultDialog.prototype.arrangeParents = function (turnOn) {
        var windowDivs = document.documentElement.querySelectorAll('.kdlg-modal-window');
        for (var i = 0; i < windowDivs.length - 1; i++) {
            if (turnOn) {
                var offset = i == 0 ? 20 : i * 40 + 20;
                domel(windowDivs[i])
                    .setStyle('margin-top', offset + "px")
                    .setStyle('margin-left', offset + "px");
            }
            else {
                domel(windowDivs[i])
                    .removeStyle('margin-top')
                    .removeStyle('margin-left');
            }
        }
    };
    return DefaultDialog;
}());
export { DefaultDialog };
var DefaultProgressDialog = /** @class */ (function (_super) {
    __extends(DefaultProgressDialog, _super);
    function DefaultProgressDialog(options, data) {
        var _this = this;
        var contentElement;
        var progressElement;
        var body = domel('div')
            .addChild('div', function (b) { return contentElement = b
            .text(options.content || '')
            .toDOM(); })
            .addChild('div', function (b) {
            b
                .addClass(cssPrefix + "-progress-line")
                .addChild('div', function (b) {
                progressElement = b
                    .addClass('fill')
                    .toDOM();
                if (options.determinated) {
                    b.setStyle('width', '0%');
                }
                else {
                    b.addClass('indeterminate');
                }
            });
        })
            .toDOM();
        _this = _super.call(this, {
            title: options.title,
            body: body,
            beforeOpen: options.beforeOpen,
            onSubmit: options.onSubmit,
            width: options.width,
            height: options.height,
            submitable: false,
            cancelable: false,
            closable: false,
            onDestroy: options.onDestroy
        }, data) || this;
        _this.contentElement = contentElement;
        _this.progressElement = progressElement;
        return _this;
    }
    DefaultProgressDialog.prototype.updateContent = function (content) {
        this.contentElement.innerText = content;
    };
    DefaultProgressDialog.prototype.updateProgress = function (progress) {
        var _this = this;
        progress = this.in01(progress);
        this.progressElement.style.width = progress * 100 + "%";
        if (progress === 1) {
            // postpone for 0.5s for smooth closing
            setTimeout(function () {
                _this.submit();
            }, 500);
        }
    };
    DefaultProgressDialog.prototype.in01 = function (num) {
        if (num > 1)
            return 1;
        if (num < 0)
            return 0;
        return num;
    };
    return DefaultProgressDialog;
}(DefaultDialog));
export { DefaultProgressDialog };
var DefaultDialogSet = /** @class */ (function () {
    function DefaultDialogSet(options, dialogService) {
        this.options = options;
        this.dialogService = dialogService;
        this.currentDialog = null;
        this.currentIndex = 0;
        this.options = options;
        this.dialogService = dialogService;
    }
    DefaultDialogSet.prototype.getCurrent = function () {
        return this.currentDialog;
    };
    DefaultDialogSet.prototype.openNext = function (data) {
        return this.open(this.currentIndex + 1, data);
    };
    DefaultDialogSet.prototype.openPrev = function (data) {
        return this.open(this.currentIndex - 1, data);
    };
    DefaultDialogSet.prototype.open = function (page, data) {
        if (page < 0) {
            this.currentIndex = 0;
        }
        else if (page >= this.options.length) {
            this.currentIndex = this.options.length - 1;
        }
        else {
            this.currentIndex = page;
        }
        if (this.currentDialog) {
            try {
                this.currentDialog.close();
            }
            catch (e) { }
        }
        var dlgOptions = this.options[this.currentIndex];
        this.currentDialog = this.dialogService.open(dlgOptions, data);
        return this.currentDialog;
    };
    DefaultDialogSet.prototype.close = function () {
        if (this.currentDialog) {
            this.currentDialog.close();
            this.currentDialog = null;
        }
    };
    return DefaultDialogSet;
}());
export { DefaultDialogSet };
//# sourceMappingURL=default_dialog_service.js.map